import { useReactiveVar } from '@apollo/client';
import { flashMessagesVar } from '../apollo/cache';
import { SPACING } from '../styles/spacing';
import convertBbcode from '../utils/convertBbcode';
import Alert from './Alert';
import { PageContainer } from './layout/Grid';

type FlashMessagesProps = {
  attentionSeeking?: boolean; // if true (which is default), bring component into view when an error appears
};

export default function FlashMessages({ attentionSeeking = true }: FlashMessagesProps) {
  const flashMessages = useReactiveVar(flashMessagesVar);

  // when a "danger" flash message appears, scroll to it
  if (Boolean(attentionSeeking) && flashMessages.some((fm) => fm.variant === 'danger')) {
    const messages = document.getElementById('flash-messages');
    const top = messages?.getBoundingClientRect().top ?? 0;
    window.scrollTo({ top: top + window.pageYOffset - parseInt(SPACING.xl), behavior: 'smooth' }); // scroll into view with an offset (nice)
  }

  return (
    <PageContainer data-testid="flash-messages" id="flash-messages">
      {flashMessages.map((flashMessage) => (
        <Alert
          key={flashMessage.id}
          variant={flashMessage.variant}
          data-testid={flashMessage.variant}
        >
          <strong>
            {typeof flashMessage.text === 'string'
              ? convertBbcode(flashMessage.text)
              : flashMessage.text}
          </strong>
        </Alert>
      ))}
    </PageContainer>
  );
}
